import Head from 'next/head'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { fetchMyRules, RuleCard } from '@/lib/rulesApi'

const STATUS_LABEL: Record<string, string> = {
  pending: '审核中',
  published: '已公开',
  rejected: '已驳回',
  draft: '草稿',
}

export default function MyRules() {
  const [rules, setRules] = useState<Array<RuleCard & { status: string }>>([])
  useEffect(() => {
    fetchMyRules().then(setRules)
  }, [])
  return (
    <>
      <Head>
        <title>我的上传 · 灵缇规则库</title>
      </Head>
      <div className="min-h-screen bg-gray-50">
        <div className="mx-auto max-w-2xl px-4 py-8">
          <div className="mb-6 flex items-center justify-between">
            <h1 className="text-2xl font-black text-gray-900">我的上传</h1>
            <Link href="/rules/upload" className="rounded-lg bg-brand px-4 py-2 text-sm text-white hover:bg-brand-dark">
              上传规则
            </Link>
          </div>
          {rules.length === 0 ? (
            <p className="py-20 text-center text-gray-400">还没有上传记录</p>
          ) : (
            <div className="space-y-3">
              {rules.map((r) => (
                <div key={r.slug} className="flex items-center justify-between rounded-xl bg-white p-4 shadow-sm">
                  <div>
                    <div className="font-bold text-gray-900">{r.title}</div>
                    <div className="text-xs text-gray-400">{r.game}</div>
                  </div>
                  <span
                    className={`rounded px-2 py-0.5 text-xs ${
                      r.status === 'published'
                        ? 'bg-green-50 text-green-600'
                        : r.status === 'rejected'
                          ? 'bg-red-50 text-red-600'
                          : 'bg-yellow-50 text-yellow-600'
                    }`}
                  >
                    {STATUS_LABEL[r.status] || r.status}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
